/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-83b9d1f1.js';
import '@carbon/icon-helpers';
import React from 'react';

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.121 19.121H26.121V23.121H24.121z",
  transform: "rotate(-45 25.121 21.121)"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 13H30V15H26z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.121 5.879H27.121V7.879H23.121z",
  transform: "rotate(-45 25.121 6.879)"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,18.1377V7A5,5,0,0,0,4,7V18.1377A6.9894,6.9894,0,1,0,16,23,6.9411,6.9411,0,0,0,14,18.1377ZM9,28a5.0057,5.0057,0,0,1-5-5,4.9164,4.9164,0,0,1,1.0747-3.06c.094-.12.1953-.2329.2993-.3437.0518-.0547.1009-.1113.1548-.1636.11-.1064.2271-.2051.3462-.3013.0425-.0346.0815-.0727.125-.1059V7a3,3,0,0,1,6,0V19.0254c.0437.0332.0828.0718.1255.1064.1189.0962.2361.1944.3454.3008.0542.0523.1038.1094.1556.1641.1037.11.205.2236.2988.3432A4.9146,4.9146,0,0,1,14,23,5.0057,5.0057,0,0,1,9,28Z"
});

var TemperatureHot16 = /*#__PURE__*/React.forwardRef(function TemperatureHot16(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref2, _ref3, _ref4, _ref5, _ref6, children);
});
export default TemperatureHot16;